module.exports = __webpack_public_path__ + "img/edit.65f23d74.svg";